import React, {
  useRef,
  useState,
  useEffect,
  useCallback,
  useLayoutEffect,
} from "react";
import SettingsIcon from "@mui/icons-material/Settings";
import { getFeatureSetOption, getFeaturesList, userRoles } from "../../../constant";
import CarIcon from "assets/svgIcons/CarIcon";
import PrintPinSheetImage from "assets/svgIcons/AdminDashboard/PrintPinSheetImage";
import ChangePicLocationImage from "assets/svgIcons/AdminDashboard/ChangePicLocationImage";
import PinPlacementManagerImage from "assets/svgIcons/AdminDashboard/PinPlacementManagerImage";
import CameraIcon from "assets/svgIcons/CameraIcon";
import Welcome from "pages/AdminDashboard/LeaderBoard/WelcomeScreen";
import { CircleBtn, ModalHeader, PopUpContainer } from "assets/css/globle";
import ModalCloseIcon from "assets/svgIcons/ModalCloseIcon";
import { COMMON_SERVICES } from "redux/reduxToolkitServices/_commonServices/commonServices";
import moment from "moment";
import {
  Header,
  BodyWrapper,
  TopRow,
  TopBox,
  CampaignAdsSlider,
  PaceFleetChartSection,
  SettingContainer,
  FilterContainer,
  TodayPinPositionModalBody,
  DragIndicatorOverlay
} from "pages/AdminDashboard/AdminDashboardStyled";
import CloseIcon from "assets/svgIcons/CloseIcon";
import { useNavigate } from "react-router-dom";
import { useHookstate } from "@hookstate/core";
import {
  SIDENAV_GLOBAL_STATE,
  GlobalCourseIdState,
  MAP_GLOBAL_STATES,
  SITEID_GLOBAL_STATE,
  DASHBOARD_GLOBAL_STATE,
  COMMON_COMPONENTS_STATES,
  ADS_GLOBAL_STATE,
} from "globalStore/globalStore";
import RoundsCompleted from "pages/AdminDashboard/LeaderBoard/RoundsCompleted/roundsCompleted";
import TodaysRound from "pages/AdminDashboard/LeaderBoard/TodaysRound/todaysRound";
import CarMovement from "pages/AdminDashboard/LeaderBoard/CarMovement/carMovement";
import CarSelection from "pages/AdminDashboard/LeaderBoard/Car Selection";
import CarSelectionIcon from "assets/svgIcons/AdminDashboard/Setting/CarSelection";
import ServiceNotificationIcon from "assets/svgIcons/AdminDashboard/Setting/ServiceNotificationIcon";
import CarMovementIcon from "assets/svgIcons/AdminDashboard/Setting/CarMovementIcon";
import GapsFlowIcon from "assets/svgIcons/AdminDashboard/Setting/GapsFlowIcon";
import CartPathSettingIcon from "assets/svgIcons/AdminDashboard/Setting/CartPathIcon";
import ActionZoneIcon from "assets/svgIcons/AdminDashboard/Setting/ActionZoneIcon";
import TodayCampaignIcon from "assets/svgIcons/AdminDashboard/Setting/TodayCampaignAdsIcon";
import { ActionZoneInfraction } from "pages/AdminDashboard/LeaderBoard/ActionZoneInfraction/ActionZoneInfraction";
import { GapManagement } from "pages/AdminDashboard/LeaderBoard/GapManagement/GapManagement";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import SelectArrow from "assets/svgIcons/SelectArrowIcon";
import { useDispatch, useSelector } from "react-redux";
import { PaceReports } from "pages/AdminDashboard/LeaderBoard/PaceReports";
import { AmpHrReport } from "pages/AdminDashboard/LeaderBoard/AmpHrReports";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { CampaignAds } from "pages/AdminDashboard/LeaderBoard/CampaignAds";
import FleetUsageReports from "pages/AdminDashboard/LeaderBoard/FleetUsageReport/fleetUsageReports";
import PaceOfPlay from "pages/AdminDashboard/LeaderBoard/PaceOfPlay/paceOfPlay";
import DashboardPace from "pages/AdminDashboard/LeaderBoard/DashboardPace";
import TodayCartPathRule from "pages/AdminDashboard/LeaderBoard/TodaysCartPathRule";
import CarRoundStatus from "pages/AdminDashboard/LeaderBoard/CarRoundStatus";
import { PinPosition } from "./Pins";
import { setAppDataReduxStateAction } from "redux/reduxToolkitServices/_commonReducers/persistedLocalStorageReducer";
import { API_STATUSES } from "redux/_helpers/statuses";
import { Loader } from "commonComponents/Loader/Loader";
import { Responsive, WidthProvider } from "react-grid-layout";
import {
  getDashboardFeatureSetStateAction,
  getDashboardFeatureSetStatusAction,
} from "redux/reduxToolkitServices/_commonReducers/commonReducers";
import "../../../../node_modules/react-grid-layout/css/styles.css";
import "../../../../node_modules/react-resizable/css/styles.css";
import _ from "lodash";
import { useTranslation } from "react-i18next";
import { useRedirectToPage } from "commonComponents/Navigation";
import { GiGolfFlag } from "react-icons/gi";

const ResponsiveGridLayout = WidthProvider(Responsive);

const layout = [
  { i: "today-pin", x: 0, y: 0, w: 1, h: 1 },
  { i: "round-completed", x: 1, y: 0, w: 1, h: 1 },
  { i: "today-round", x: 2, y: 0, w: 1, h: 1 },
  { i: "pace-report", x: 3, y: 0, w: 1, h: 1 },
  { i: "amp-hr", x: 4, y: 0, w: 1, h: 1 },
  { i: "dash-pace", x: 5, y: 1, w: 1, h: 1 },
  { i: "car-movement", x: 6, y: 1, w: 1, h: 1 },
];

const middleLayout = [
  { i: "car-round-status", x: 0, y: 2, w: 1, h: 1 },
  { i: "welcome", x: 1, y: 2, w: 1, h: 1 },
  { i: "map-section", x: 2, y: 2, w: 1, h: 1 },
  { i: "weather-info", x: 3, y: 2, w: 1, h: 1 },
  { i: "car-selection", x: 4, y: 2, w: 1, h: 1 },
  { i: "cart-path-rule", x: 5, y: 2, w: 1, h: 1 },
  { i: "action-zone-infraction", x: 1, y: 3, w: 1, h: 1 },
];

const useLongPressDragMobile = () => {
  const [dragActivated, setDragActivated] = useState(false);
  const touchTimerRef = useRef(null);
  const touchStartRef = useRef({ x: 0, y: 0 });
  const LONG_PRESS_DURATION = 500;
  const MOVEMENT_THRESHOLD = 10;

  const isMobile = () => window.innerWidth < 1300;

  const handleTouchStart = (e) => {
    if (!isMobile()) return;

    const touch = e.touches[0];
    touchStartRef.current = { x: touch.clientX, y: touch.clientY };
    setDragActivated(false);

    touchTimerRef.current = setTimeout(() => {
      setDragActivated(true);
      // Add long press active feedback  
      if (navigator.vibrate) {
        navigator.vibrate(50);
      }
    }, LONG_PRESS_DURATION);
  };

  const handleTouchMove = (e) => {
    if (!isMobile() || !touchTimerRef.current) return;

    const touch = e.touches[0];
    const moveX = Math.abs(touch.clientX - touchStartRef.current.x);
    const moveY = Math.abs(touch.clientY - touchStartRef.current.y);

    if (moveX > MOVEMENT_THRESHOLD || moveY > MOVEMENT_THRESHOLD) {
      clearTimeout(touchTimerRef.current);
      touchTimerRef.current = null;
      setDragActivated(false);
    }
  };

  const handleTouchEnd = () => {
    if (touchTimerRef.current) {
      clearTimeout(touchTimerRef.current);
      touchTimerRef.current = null;
    }
  };

  return {
    handleTouchStart,
    handleTouchMove,
    handleTouchEnd,
    dragActivated,
    isMobile,
  };
};
export const LeaderBoard = () => {
  const { resetGlobalCourseId } = useHookstate(GlobalCourseIdState);
  const { t } = useTranslation();

  const navigate = useNavigate();
  const { subNavDataState, sideDrawerActiveTabState } = useHookstate(SIDENAV_GLOBAL_STATE);
  const { globalCourseId, setCourseId } = useHookstate(GlobalCourseIdState);
  const { siteId, hideSubNav } = useHookstate(SITEID_GLOBAL_STATE);
  const {
    siteSettingsData,
    getDashboardFeatureSetState,
    getDashboardFeatureSetStatus,
    putDashboardFeatureSetStatus,
    getUserRole,
    siteLocationsData,
    greensWithPinPlacementStateData,
    getWelcomeAdsData
  } = useSelector((state) => state.commonReducers) || [];

  const dispatch = useDispatch();

  const { callSiteSelection } = useHookstate(MAP_GLOBAL_STATES);
  const { localSiteTimeState } = useHookstate(COMMON_COMPONENTS_STATES);
  const { actionZoneData, batteryStatus, paceReportData } = useHookstate(DASHBOARD_GLOBAL_STATE);
  const { alertMsg, redirectState, nextTabIndex, nextStageName } = useHookstate(ADS_GLOBAL_STATE);

  const [isShown, setIsShown] = useState(false);
  const [fleetRoationCard, setFleetRoationCard] = useState(true);
  const [fleetUsageReportCard, setFleetUsageReportCard] = useState(true);
  const [fleetReadinessCard, setFleetReadinessCard] = useState(true);
  const [pacePlayReportCard, setPacePlayReportCard] = useState(true);
  const [chatCamCard, setChatCamCard] = useState(true);
  const [ghinCard, setGhinCard] = useState(true);
  const [weatherCard, setWeatherCard] = useState(true);
  const [welcomeCard, setWelcomeCard] = useState(true);
  const [batteryNotificationCard, setBatteryNotificationCard] = useState(true);
  const [carSelectionCard, setCarSelectionCard] = useState(true);
  const [gapManagementCard, setGapManagementCard] = useState(true);
  const [todayCartPathCard, setTodayCartPathCard] = useState(true);
  const [actionZoneCard, setActionZoneCard] = useState(true);
  const [todayCampaignAdsCard, setTodayCampaignAdsCard] = useState(true);
  const [todayPinPositionCard, setTodayPinPositionCard] = useState(true);
  const [carMovementCard, setCarMovementCard] = useState(true);
  const [carsBehindPaceCard, setCarsBehindPaceCard] = useState(true);
  const [paceFastSlowestCard, setPaceFastSlowestCard] = useState(true);
  const [roundCompletedCard, setRoundCompletedCard] = useState(true);
  const [todayRoundsCard, setTodayRoundsCard] = useState(true);
  const [carRoundStatusCard, setCarRoundStatusCard] = useState(true);
  const [paceReportCard, setPaceReportCard] = useState(true);
  const [mapCard, setMapCard] = useState(true);
  const [ampHrCard, setAmpHrCard] = useState(true);
  const [openModal, setOpenModal] = useState(false);
  const [dashDragState, setDragState] = useState(false);
  const [courseList, setCourseList] = React.useState([]);
  const [currentDate, setCurrentDate] = useState("");
  const [layoutPayload, setLayoutPayload] = useState([]);
  const [middlelayoutPayload, setMiddleLayoutPayload] = useState([]);
  const [detectSaveChanges, setDetectSaveChanges] = useState(false);
  const [saveModalState, setSaveModalState] = useState(false);
  const layoutChangeSource = useRef("init");

  const clickedElement = useRef(null);

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: { xs: "calc(100% - 32px)", sm: 700, md: 900 },
    maxWidth: 900,
    bgcolor: "background.paper",
    background: "#FFFFFF",
    boxShadow: "0px 14px 100px 30px rgba(0, 0, 0, 0.3)",
    borderRadius: "20px",
    outline: "none",
    maxHeight: "80vh",
    px: { xs: 2, sm: 4 },
    boxSizing: "border-box",
  };

  const style1 = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    maxWidth: 444,
    bgcolor: "background.paper",
    boxShadow: 24,
    width: "100%",
    background: "#FFFFFF",
    boxShadow: "0px 14px 100px 30px rgba(0, 0, 0, 0.3)",
    borderRadius: "4px",
    outline: "none",
  }

  const handleModalOpen = () => setOpenModal(true);
  const handleModalClose = () => setOpenModal(false);
  const { handleTouchStart, handleTouchMove, handleTouchEnd, dragActivated, isMobile } = useLongPressDragMobile();

  const showData = [
    {
      id: 0,
      comp: <PinPosition />,
      renderFunction: "pins",
      classname: "",
      condition: todayPinPositionCard,
      compKey: "today-pin",
    },
    {
      id: 1,
      comp: <RoundsCompleted />,
      renderFunction: "roundsCompleted",
      classname: "fleet-car-rotation",
      condition: roundCompletedCard,
      compKey: "round-completed",
    },
    {
      id: 2,
      comp: <TodaysRound />,
      renderFunction: "ampreports",
      classname: "",
      condition: todayRoundsCard,
      compKey: "today-round",
    },
    {
      id: 3,
      comp: <PaceReports />,
      renderFunction: "",
      classname: "",
      condition: paceReportCard,
      compKey: "pace-report",
    },
    {
      id: 4,
      comp: <AmpHrReport />,
      renderFunction: "ampreports",
      classname: "",
      condition: ampHrCard,
      compKey: "amp-hr",
    },
    {
      id: 5,
      comp: <DashboardPace />,
      renderFunction: "dashPace",
      classname: "",
      condition: paceFastSlowestCard,
      compKey: "dash-pace",
    },
    {
      id: 6,
      comp: <CarMovement />,
      renderFunction: "",
      classname: "",
      condition: carMovementCard,
      compKey: "car-movement",
    },
  ];

  const showMiddleLayout = [
    {
      id: 7,
      comp: <CarRoundStatus />,
      renderFunction: "pre-round",
      classname: "",
      condition: carRoundStatusCard,
      compKey: "car-round-status",
    },
    {
      id: 8,
      comp: <Welcome />,
      renderFunction: "welcome",
      classname: "",
      condition: welcomeCard,
      compKey: "welcome",
    },
    {
      id: 9,
      comp: <CarSelection />,
      renderFunction: "",
      classname: "",
      condition: carSelectionCard,
      compKey: "car-selection",
    },
    {
      id: 10,
      comp: <TodayCartPathRule />,
      renderFunction: "car-path", // need to add car path string
      classname: "",
      condition: todayCartPathCard,
      compKey: "cart-path-rule",
    },
    {
      id: 11,
      comp: <ActionZoneInfraction />,
      renderFunction: "",
      classname: "",
      condition: actionZoneCard,
      compKey: "action-zone-infraction",
    },
    {
      id: 12,
      comp: <GapManagement />,
      renderFunction: "pace",
      classname: "",
      condition: gapManagementCard,
      compKey: "gap-management",
    },
  ];

  useEffect(() => {
    if (siteLocationsData?.length === 1 && localStorage.getItem("dashCourseId") === null) {
      localStorage.setItem("dashCourseId", resetGlobalCourseId.get())
    }
  }, [siteLocationsData]);

  useEffect(() => {
    if (siteId.get() !== null) {
      dispatch(COMMON_SERVICES.getDashboardFeatureSetServices()).then(() => {
        setDetectSaveChanges(false);
      });
    }
    dispatch(COMMON_SERVICES.getCampaignsServices(siteId.get()));
    return () => {
      dispatch(getDashboardFeatureSetStateAction({}));
      dispatch(getDashboardFeatureSetStatusAction(API_STATUSES.IDLE));
    };
  }, [siteId.get()]);

  useEffect(() => {
    if (
      siteId.get() !== null &&
      siteSettingsData &&
      Object.keys(siteSettingsData).length > 0
    ) {
      setCurrentDate(
        moment(new Date())
          .utc()
          .utcOffset(-siteSettingsData?.TimeZoneOffset)
          .format("dddd MMMM DD, YYYY")
      );
      setCourseList(siteSettingsData);
    }
  }, [siteId.get(), siteSettingsData]);

  useEffect(() => {
    if (getDashboardFeatureSetState && Object.keys(getDashboardFeatureSetState).length !== 0 &&
      getDashboardFeatureSetState?.DashboardFeatures !== null &&
      getDashboardFeatureSetState?.DashboardLayout !== null) {
      handleTileToggle();
    }
  }, [getDashboardFeatureSetState]);

  useLayoutEffect(() => {
    if (layoutChangeSource.current === "drag" && Object.keys(layoutPayload).length > 0 && Object.keys(middlelayoutPayload).length > 0) {
      layoutChangeSource.current = "init";
      handlerSaveLayout();
    }
  }, [layoutPayload, middlelayoutPayload]);

  const redirectToPage = useRedirectToPage();

  function handleTileToggle() {
    if (getDashboardFeatureSetState && getDashboardFeatureSetState?.DashboardFeatures !== null && Object.keys(getDashboardFeatureSetState).length !== 0 && Object.keys(getDashboardFeatureSetState?.DashboardFeatures).length !== 0) {
      let checkValue = JSON.parse(getDashboardFeatureSetState?.DashboardFeatures);

      setFleetRoationCard(checkValue?.fleetUtilization);
      setCarsBehindPaceCard(checkValue?.carBehind);
      setTodayPinPositionCard(checkValue?.todayPin);
      setRoundCompletedCard(checkValue?.roundCompleted);
      setTodayRoundsCard(checkValue?.todayRound);
      setChatCamCard(checkValue?.chatCam);
      setGhinCard(checkValue?.ghin);
      setPaceReportCard(checkValue?.paceReport);
      setAmpHrCard(checkValue?.ampHr);
      setPaceFastSlowestCard(checkValue?.dashPace);
      setFleetReadinessCard(checkValue?.readiness);
      setCarMovementCard(checkValue?.carMovement);
      setCarRoundStatusCard(checkValue?.carRoundStatus);
      setWelcomeCard(checkValue?.welcome);
      setWeatherCard(checkValue?.welcomeInfo);
      setMapCard(checkValue?.map);
      setCarSelectionCard(checkValue?.carSelection);
      setTodayCartPathCard(checkValue?.carPath);
      setBatteryNotificationCard(checkValue?.batteryNotification);
      setActionZoneCard(checkValue?.actionzoneInfraction);
      setFleetUsageReportCard(checkValue?.fleetUsageReport);
      setPacePlayReportCard(checkValue?.paceOfPlay);
      setTodayCampaignAdsCard(checkValue?.todayCampaign);
      setGapManagementCard(checkValue?.gapManagement);
    }
  }

  const handleLayoutChange = useCallback(
    (newLayout) => {
      let tempNewLayout = JSON.parse(JSON.stringify(newLayout));

      let yExtraValue = tempNewLayout.filter((el) => {
        return el.y !== 0 && el.y !== 1;
      });

      let correctValues = tempNewLayout.filter((el) => {
        return el.y === 0 || el.y === 1;
      });

      if (yExtraValue.length > 0) {
        let xAtYzero = tempNewLayout.filter((el) => {
          return el.y === 0;
        });

        let xAtYone = tempNewLayout.filter((el) => {
          return el.y === 1;
        });

        let xCountYzero = xAtYzero.length;
        let xCountYone = xAtYone.length;

        yExtraValue.forEach((item) => {
          if (xCountYzero < 6) {
            item.x = xCountYzero;
            item.y = 0;
            xCountYzero++;
          } else if (xCountYone < 6) {
            item.x = xCountYone;
            item.y = 1;
            xCountYone++;
          }
          correctValues.push(item);
        });
      }
      setLayoutPayload(correctValues);
    },
    [layoutPayload]
  );

  const handleMiddleLayoutChange = useCallback(
    (newLayout) => {
      let tempNewLayout = JSON.parse(JSON.stringify(newLayout));

      let yExtraValue = tempNewLayout.filter((el) => {
        return el.y !== 0 && el.y !== 1;
      });

      let correctValues = tempNewLayout.filter((el) => {
        return el.y === 0 || el.y === 1;
      });

      if (yExtraValue.length > 0) {
        let xAtYzero = tempNewLayout.filter((el) => {
          return el.y === 0;
        });

        let xAtYone = tempNewLayout.filter((el) => {
          return el.y === 1;
        });

        let xCountYzero = xAtYzero.length;
        let xCountYone = xAtYone.length;

        yExtraValue.forEach((item) => {
          if (xCountYzero < 4) {
            item.x = xCountYzero;
            item.y = 0;
            xCountYzero++;
          } else if (xCountYone < 4) {
            item.x = xCountYone;
            item.y = 1;
            xCountYone++;
          }
          correctValues.push(item);
        });
      }

      setMiddleLayoutPayload(correctValues);
    },
    [middlelayoutPayload]
  );

  useEffect(() => {
    if (detectSaveChanges) {
      redirectState.set(true);
    } else {
      redirectState.set(false);
    }
  }, [detectSaveChanges]);

  function handleDiscardChanges() {
    redirectState.set(false);
    alertMsg.set(false);
    if (saveModalState) {
      dispatch(COMMON_SERVICES.getDashboardFeatureSetServices()).then(() => {
        setIsShown(false);
        setDetectSaveChanges(false);
      });
      setSaveModalState(false);
    } else {
      setIsShown(false);
      hideSubNav.set(true);
      if (nextStageName.get() === "siteSelection") {
        callSiteSelection.set(true);
        return;
      }
      navigate(`/${nextStageName.get().toLowerCase()}`);
      let activeTab = nextTabIndex.get();
      let activeName = nextStageName.get();
      sideDrawerActiveTabState.set(activeTab);
      subNavDataState.set(activeName);

      localStorage.setItem("sideDrawerActiveTabState", nextTabIndex.get());

      localStorage.setItem("subNavState", "true");
      localStorage.setItem("subNavDataState", nextStageName.get());
    }
  }

  const handleClick = () => {
    if (detectSaveChanges) {
      alertMsg.set(true);
      setSaveModalState(true);
    } else {
      setIsShown((current) => !current);
    }
  }

  const handleCourseName = (e) => {
    globalCourseId.set(e.target.value);
    setCourseId.set(e.target.value);
    localStorage.setItem("dashCourseId", e.target.value);
    dispatch(
      setAppDataReduxStateAction({
        value: e.target.value,
        parameterDetector: "coursenumber",
      })
    );
  }

  const modal = () => {
    return (
      <Modal
        open={openModal}
        onClose={handleModalClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <ModalHeader>
            <h2>{t("Todays_Pin_Position")}</h2>
            <ModalCloseIcon onClick={handleModalClose} />
          </ModalHeader>
          <TodayPinPositionModalBody>
            <TopBox onClick={() => redirectToPage("print")}>
              <div className="header">
                <CarIcon width={25} height={20} />
                <p className="green-border">{t("Print_Pin_Sheet")}</p>
              </div>
              <div className="box-body">
                <PrintPinSheetImage />
              </div>
            </TopBox>
            <TopBox onClick={() => redirectToPage("location")}>
              <div className="header">
                <CarIcon width={25} height={20} />
                <p className="green-border"> {t("Change_Pin_Location")}</p>
              </div>
              <div className="box-body">
                <ChangePicLocationImage />
              </div>
            </TopBox>
            <TopBox onClick={() => redirectToPage("placement")}>
              <div className="header">
                <CarIcon width={25} height={20} />
                <p className="green-border">{t("Pin_Rotation")}</p>
              </div>
              <div className="box-body">
                <PinPlacementManagerImage />
              </div>
            </TopBox>
          </TodayPinPositionModalBody>
        </Box>
      </Modal>
    );
  }

  function handlerSaveLayout() {
    let featureLayout = {
      upperLayout: JSON.stringify(layoutPayload),
      middleLayout: JSON.stringify(middlelayoutPayload),
    };

    let featureSet = {
      fleetUtilization: fleetRoationCard,
      carBehind: carsBehindPaceCard,
      todayPin: todayPinPositionCard,
      roundCompleted: roundCompletedCard,
      todayRound: todayRoundsCard,
      chatCam: chatCamCard,
      ghin: ghinCard,
      paceReport: paceReportCard,
      ampHr: ampHrCard,
      dashPace: paceFastSlowestCard,
      readiness: fleetReadinessCard,
      carMovement: carMovementCard,
      carRoundStatus: carRoundStatusCard,
      welcome: welcomeCard,
      welcomeInfo: weatherCard,
      map: mapCard,
      carSelection: carSelectionCard,
      carPath: todayCartPathCard,
      batteryNotification: batteryNotificationCard,
      actionzoneInfraction: actionZoneCard,
      paceOfPlay: pacePlayReportCard,
      fleetUsageReport: fleetUsageReportCard,
      todayCampaign: todayCampaignAdsCard,
      gapManagement: gapManagementCard,
    };
    let modifiedDate = moment(new Date()).utc().format();

    let payload = {
      Id: 0,
      UserId: 0,
      LastModifiedInUtc: modifiedDate,
      DashboardFeatures: JSON.stringify(featureSet),
      DashboardLayout: JSON.stringify(featureLayout),
      User: null,
    };

    setDetectSaveChanges(false);
    dispatch(COMMON_SERVICES.putDashboardFeatureSetServices(payload)).then(
      () => {
        setIsShown(false);
        if (siteId.get() !== null) {
          dispatch(COMMON_SERVICES.getDashboardFeatureSetServices());
        }
      }
    );
  }

  function toggleWidgetVisibility(widgetName) {
    switch (widgetName) {

      case "car-movement":
        {
          setCarMovementCard(!carMovementCard);
          setDetectSaveChanges(true);
        }
        break;
      case "dash-pace":
        {
          setPaceFastSlowestCard(!paceFastSlowestCard);
          setDetectSaveChanges(true);
        }
        break;
      case "round-completed":
        {
          setRoundCompletedCard(!roundCompletedCard);
          setDetectSaveChanges(true);
        }
        break;
      case "today-round":
        {
          setTodayRoundsCard(!todayRoundsCard);
          setDetectSaveChanges(true);
        }
        break;
      case "today-pin":
        {
          setTodayPinPositionCard(!todayPinPositionCard);
          setDetectSaveChanges(true);
        }
        break;
      case "pace-report":
        {
          setPaceReportCard(!paceReportCard);
          setDetectSaveChanges(true);
        }
        break;
      case "amp-hr":
        {
          setAmpHrCard(!ampHrCard);
          setDetectSaveChanges(true);
        }
        break;
      default:
    }
  }

  function ContainerBox() {
    return (
      <SettingContainer>
        <div className="close-icon-wrapper">
          <Modal
            open={alertMsg.get()}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            maxWidth="sm"
          >
            <Box sx={style1}>
              <PopUpContainer>
                <h2>{t("Confirm")}</h2>
                <p>{t("Discard_changes")} ?</p>

                <div className="action-btn">
                  <button onClick={handleDiscardChanges} className="primary">
                    {t("Yes")}
                  </button>
                  <button
                    onClick={() => {
                      alertMsg.set(false);
                      setSaveModalState(false);
                    }}
                  >
                    {t("No")}
                  </button>
                </div>
              </PopUpContainer>
            </Box>
          </Modal>
          <button onClick={handleClick}>
            {t("Close")} <CloseIcon />
          </button>
        </div>
        <FilterContainer>
          <div>
            <h3>{t("Standard_Connectivity")}</h3>
            <button
              className={carSelectionCard ? "selected" : ""}
              onClick={() => {
                setCarSelectionCard(!carSelectionCard);
                setDetectSaveChanges(true);
              }}
            >
              <CarSelectionIcon />
              {t("Car_Selection")}
            </button>

          </div>
          <div>
            <h3 className="yellow-border">{t("Car_Tracking_and_POP")}</h3>
            <button
              className={carMovementCard ? "selected" : ""}
              onClick={() => {
                toggleWidgetVisibility("car-movement");
              }}
            >
              <CarMovementIcon />
              {t("Car_movement")}
            </button>

            <button
              className={
                paceFastSlowestCard &&
                  !getFeatureSetOption(
                    siteSettingsData && siteSettingsData?.Features,
                    getFeaturesList().real_time_tracking
                  )
                  ? "selected"
                  : ""
              }
              onClick={() => {
                setPaceFastSlowestCard(!paceFastSlowestCard);
                setDetectSaveChanges(true);
              }}
              disabled={
                getFeatureSetOption(
                  siteSettingsData && siteSettingsData?.Features,
                  getFeaturesList().real_time_tracking
                ) &&
                getUserRole &&
                getUserRole.Role != 6
              }
            >
              <ServiceNotificationIcon />
              Pace: Fastest / Slowest
            </button>
            <button
              className={roundCompletedCard ? "selected" : ""}
              onClick={() => {
                toggleWidgetVisibility("round-completed");
              }}
            >
              <ServiceNotificationIcon />
              Round Completed
            </button>
            <button
              className={
                paceReportCard &&
                  !getFeatureSetOption(
                    siteSettingsData && siteSettingsData?.Features,
                    getFeaturesList().real_time_tracking
                  )
                  ? "selected"
                  : ""
              }
              onClick={() => {
                toggleWidgetVisibility("pace-report");
              }}
            >
              <ServiceNotificationIcon />
              {t("Current_Pace")}
            </button>
            <button
              className={ampHrCard ? "selected" : ""}
              onClick={() => {
                toggleWidgetVisibility("amp-hr");
              }}
            >
              <ServiceNotificationIcon />
              {t("AMP_HR_Report")}
            </button>
            <button
              className={
                todayRoundsCard &&
                  !getFeatureSetOption(
                    siteSettingsData && siteSettingsData?.Features,
                    getFeaturesList().real_time_tracking
                  )
                  ? "selected"
                  : ""
              }
              onClick={() => {
                toggleWidgetVisibility("today-round");
              }}
              disabled={
                getFeatureSetOption(
                  siteSettingsData && siteSettingsData?.Features,
                  getFeaturesList().real_time_tracking
                ) &&
                getUserRole &&
                getUserRole.Role != 6
              }
            >
              <ServiceNotificationIcon />
              {t("Todays_Rounds")}
            </button>
            <button
              className={
                carRoundStatusCard &&
                  !getFeatureSetOption(
                    siteSettingsData && siteSettingsData?.Features,
                    getFeaturesList().real_time_tracking
                  )
                  ? "selected"
                  : ""
              }
              onClick={() => {
                setCarRoundStatusCard(!carRoundStatusCard);
                setDetectSaveChanges(true);
              }}
              disabled={
                getFeatureSetOption(
                  siteSettingsData && siteSettingsData?.Features,
                  getFeaturesList().real_time_tracking
                ) &&
                getUserRole &&
                getUserRole.Role != 6
              }
            >
              <ServiceNotificationIcon />
              {t("Car_Round_Status")}
            </button>
          </div>
          <div>
            <h3 className="red-border">{t("Car_Control")}</h3>
            <button
              className={todayCartPathCard ? "selected" : ""}
              onClick={() => {
                setTodayCartPathCard(!todayCartPathCard);
                setDetectSaveChanges(true);
              }}
            >
              <CartPathSettingIcon />
              {t("Todays_Cart_Path_Rule")}
            </button>
            <button
              className={actionZoneCard ? "selected" : ""}
              onClick={() => {
                setActionZoneCard(!actionZoneCard);
                setDetectSaveChanges(true);
              }}
            >
              <ActionZoneIcon />
              {t("Action_Zone_Infraction")}
            </button>
          </div>
          <div>
            <h3 className="green-border">{t("Golfer_Experience")}</h3>
            <button
              className={
                todayPinPositionCard &&
                  !getFeatureSetOption(
                    siteSettingsData && siteSettingsData?.Features,
                    getFeaturesList().golfer_experience
                  )
                  ? "selected"
                  : ""
              }
              onClick={() => {
                toggleWidgetVisibility("today-pin");
              }}
              disabled={
                getFeatureSetOption(
                  siteSettingsData && siteSettingsData?.Features,
                  getFeaturesList().golfer_experience
                ) &&
                getUserRole &&
                getUserRole.Role != 6
              }
            >
              <CarMovementIcon />
              {t("Todays_Pin_Position")}
            </button>
            <button
              className={todayCampaignAdsCard ? "selected" : ""}
              onClick={() => {
                setTodayCampaignAdsCard(!todayCampaignAdsCard);
                setDetectSaveChanges(true);
              }}
            >
              <TodayCampaignIcon />
              {t("Todays_Campaign_Ads")}
            </button>
            <button
              className={welcomeCard ? "selected" : ""}
              onClick={() => {
                setWelcomeCard(!welcomeCard);
                setDetectSaveChanges(true);
              }}
            >
              <GapsFlowIcon />
              {t("Welcome_Screen")}
            </button>
            <button
              className={gapManagementCard ? "selected" : ""}
              onClick={() => {
                setGapManagementCard(!gapManagementCard);
                setDetectSaveChanges(true);
              }}
            >
              <GiGolfFlag style={{ width: 26, height: 26, backgroundColor: "#352A1F", borderRadius: 6, fill: "#A5885D" }} />
              {t("Gap_Management")}
            </button>
          </div>
          <div>
            <h3 className="brown-border">{t("Other")}</h3>
            <button
              className={
                pacePlayReportCard &&
                  !getFeatureSetOption(
                    siteSettingsData && siteSettingsData?.Features,
                    getFeaturesList().real_time_tracking
                  )
                  ? "selected"
                  : ""
              }
              onClick={() => {
                setPacePlayReportCard(!pacePlayReportCard);
                setDetectSaveChanges(true);
              }}
              disabled={
                getFeatureSetOption(
                  siteSettingsData && siteSettingsData?.Features,
                  getFeaturesList().real_time_tracking
                ) &&
                getUserRole &&
                getUserRole.Role != 6
              }
            >
              <ActionZoneIcon />
              {t("Pace_of_Play_Reports")}
            </button>
            <button
              className={fleetUsageReportCard ? "selected" : ""}
              onClick={() => {
                setFleetUsageReportCard(!fleetUsageReportCard);
                setDetectSaveChanges(true);
              }}
            >
              <TodayCampaignIcon />
              {t("Fleet_Usage_Reports")}
            </button>
          </div>
        </FilterContainer>
        <div className="action-wrapper">
          <CircleBtn
            disabled={!detectSaveChanges}
            className={detectSaveChanges ? "active" : "disabled"}
            onClick={handlerSaveLayout}
          >
            {t("Save")}
          </CircleBtn>
          <CircleBtn
            onClick={() => {
              if (detectSaveChanges) {
                alertMsg.set(true);
                setSaveModalState(true);
              } else {
                setIsShown(false);
                setDetectSaveChanges(false);
              }
            }}
          >
            {t("Cancel")}
          </CircleBtn>
        </div>
      </SettingContainer>
    );
  }

  const getLayouts = () => {
    if (getDashboardFeatureSetState && getDashboardFeatureSetState !== undefined && Object.keys(getDashboardFeatureSetState).length !== 0) {
      let savedLayouts = JSON.parse(
        getDashboardFeatureSetState?.DashboardLayout
      );

      if (
        savedLayouts &&
        savedLayouts.length !== 0 &&
        savedLayouts !== null &&
        savedLayouts?.upperLayout !== undefined
      ) {
        if (detectSaveChanges) {
          return layoutPayload;
        } else {
          return JSON.parse(savedLayouts?.upperLayout);
        }
      }
    }

    return layout;
  }

  const handleMouseDown = (e) => {
    clickedElement.current = e.target.closest('[data-section]');
  }

  const getMiddleLayouts = () => {
    if (getDashboardFeatureSetState && getDashboardFeatureSetState !== undefined && Object.keys(getDashboardFeatureSetState).length !== 0) {
      let savedLayouts = JSON.parse(getDashboardFeatureSetState?.DashboardLayout);

      if (savedLayouts && savedLayouts.length !== 0 && savedLayouts !== null && savedLayouts?.middleLayout !== undefined) {
        if (detectSaveChanges) {
          return middlelayoutPayload;
        } else {
          return JSON.parse(savedLayouts?.middleLayout);
        }
      }
    }

    return middleLayout;
  }

  if (putDashboardFeatureSetStatus === API_STATUSES.REQUEST || getDashboardFeatureSetStatus === API_STATUSES.REQUEST || siteId.get() === null) {
    return <Loader />;
  }

  return (
    <>
      {!(greensWithPinPlacementStateData && greensWithPinPlacementStateData.EzLocatorCourse) && modal()}
      {dragActivated && <DragIndicatorOverlay active={dragActivated} />}
      <Header>
        <div className="heading">
          <p>
            <span>{currentDate}</span> {localSiteTimeState.get()}
          </p>
        </div>
        <div className="role-wrapper">
          <FormControl>
            <Select
              native
              labelId="demo-controlled-open-select-label"
              id="demo-controlled-open-select"
              variant="outlined"
              value={localStorage.getItem("dashCourseId")}
              onChange={handleCourseName}
              IconComponent={() => (
                <div className="arrow-icon">
                  <SelectArrow />
                </div>
              )}
            >
              {courseList &&
                courseList?.Courses &&
                courseList?.Courses.length !== 0 ? (
                courseList?.Courses.map((item) => (
                  <option key={item?.Number} value={item?.Number}>
                    {item?.Name}
                  </option>
                ))
              ) : (
                <option value=""></option>
              )}
            </Select>
          </FormControl>
          <button onClick={handleClick}>
            <SettingsIcon />
          </button>
        </div>
        {isShown && <>{ContainerBox()}</>}
      </Header>

      <BodyWrapper
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
      >
        <TopRow onMouseDown={handleMouseDown}>
          <ResponsiveGridLayout
            layouts={{ lg: getLayouts() }}
            breakpoints={{ lg: 1700, md: 1300, mobile: 820, sm: 768, xs: 480 }}
            cols={{ lg: 6, md: 5, mobile: 1, sm: 1, xs: 1, xxs: 1 }}

            rowHeight={300}
            width={1841}
            margin={[20, 20]}
            compactType="horizontal"
            isDraggable={isMobile() ? dragActivated : true}
            isBounded={false}
            onLayoutChange={(newLayout) => handleLayoutChange(newLayout)}
            onDrag={() => setDragState(true)}
            onDragStop={(_, oldItem) => {
              if (dashDragState) {
                setDragState(false);
                (oldItem.i === "pace-report" || oldItem.i === "car-movement") && paceReportData.set("");
                layoutChangeSource.current = "drag";
              }
              else {
                const item = showData.filter((i) => i.compKey === oldItem.i);
                if (Object.keys(item).length > 0 && typeof item[0]?.renderFunction === "string" && item[0]?.renderFunction !== "") {
                  if (item[0]?.renderFunction === "pins") {
                    redirectToPage(item[0]?.renderFunction, handleModalOpen);
                  }
                  else {
                    redirectToPage(item[0]?.renderFunction);
                  }
                }
                else if (oldItem.i === "pace-report" || oldItem.i === "car-movement") {
                  paceReportData.set(clickedElement.current?.dataset.section);
                }
              }
            }}
          >
            {showData
              .filter((it) => {
                if (
                  !getFeatureSetOption(
                    siteSettingsData && siteSettingsData?.Features,
                    getFeaturesList().real_time_tracking,
                    getFeaturesList().golfer_experience
                  ) &&
                  !getFeatureSetOption(
                    siteSettingsData && siteSettingsData?.Features,
                    getFeaturesList().car_control
                  ) &&
                  getUserRole &&
                  getUserRole.Role != 6
                ) {
                  return it;
                } else if (
                  !getFeatureSetOption(
                    siteSettingsData && siteSettingsData?.Features,
                    getFeaturesList().real_time_tracking
                  ) &&
                  getUserRole &&
                  getUserRole.Role != 6 &&
                  (it.compKey == "car-behind" ||
                    it.compKey == "today-round" ||
                    it.compKey == "pace-report" ||
                    it.compKey == "dash-pace")
                ) {
                  return it;
                } else if (
                  !getFeatureSetOption(
                    siteSettingsData && siteSettingsData?.Features,
                    getFeaturesList().car_control
                  ) &&
                  getUserRole &&
                  getUserRole.Role != 6 &&
                  it.compKey == "fleet-car"
                ) {
                  return it;
                } else if (
                  !getFeatureSetOption(
                    siteSettingsData && siteSettingsData?.Features,
                    getFeaturesList().golfer_experience
                  ) &&
                  getUserRole &&
                  getUserRole.Role != 6 &&
                  (it.compKey == "today-pin" || it.compKey == "ghin")
                ) {
                  return it;
                } else if (
                  it.compKey != "car-behind" &&
                  it.compKey != "today-pin" &&
                  it.compKey != "today-round" &&
                  it.compKey != "pace-report" &&
                  it.compKey != "ghin" &&
                  it.compKey != "dash-pace" &&
                  it.compKey != "fleet-car"
                ) {
                  return it;
                }
              })
              ?.map((d) => {
                return d?.condition ? (
                  <TopBox
                    key={d?.compKey}
                    className={d.classname ? d.classname : ""}
                  >
                    {d?.comp}
                  </TopBox>
                ) : (
                  <></>
                );
              })}
          </ResponsiveGridLayout>
        </TopRow>

        <TopRow onMouseDown={handleMouseDown}>
          <ResponsiveGridLayout
            layouts={{ lg: getMiddleLayouts() }}
            breakpoints={{ lg: 1600, md: 1360, mobile: 820, sm: 768, xs: 480 }}
            cols={{ lg: 6, md: 5, mobile: 1, sm: 1, xs: 1, xxs: 1 }}

            rowHeight={400}
            width={1841}
            margin={[20, 20]}
            compactType="horizontal"
            isDraggable={isMobile() ? dragActivated : true}
            isBounded={false}
            onLayoutChange={(newLayout) => handleMiddleLayoutChange(newLayout)}
            onDrag={() => setDragState(true)}
            onDragStop={(_, oldItem) => {
              if (dashDragState) {
                setDragState(false);
                oldItem.i === "action-zone-infraction" && actionZoneData.set("");
                oldItem.i === "car-selection" && batteryStatus.set("");
                layoutChangeSource.current = "drag";
              }
              else {
                const item = showMiddleLayout.filter((i) => i.compKey === oldItem.i);
                if (Object.keys(item).length > 0 && typeof item[0]?.renderFunction === "string" && item[0]?.renderFunction !== "") {
                  redirectToPage(item[0]?.renderFunction, null, getWelcomeAdsData?.Id);
                }
                else if (oldItem.i === "action-zone-infraction") {
                  actionZoneData.set(clickedElement.current?.dataset.section);
                }
                else if (oldItem.i === "car-selection") {
                  batteryStatus.set(clickedElement.current?.dataset.section);
                }
              }
            }}
          >
            {showMiddleLayout
              .filter((it) => {
                if (!getFeatureSetOption(siteSettingsData && siteSettingsData?.Features, getFeaturesList().real_time_tracking, getFeaturesList().golfer_experience) &&
                  !getFeatureSetOption(siteSettingsData && siteSettingsData?.Features, getFeaturesList().car_control) && getUserRole && getUserRole.Role != userRoles.BasicUser) {
                  return it;
                } else if (
                  !getFeatureSetOption(siteSettingsData && siteSettingsData?.Features, getFeaturesList().real_time_tracking) && getUserRole && getUserRole.Role != userRoles.BasicUser &&
                  (it.compKey == "car-behind" ||
                    it.compKey == "today-round" ||
                    it.compKey == "pace-report" ||
                    it.compKey == "dash-pace" ||
                    it.compKey == "car-round-status")
                ) {
                  return it;
                } else if (
                  !getFeatureSetOption(
                    siteSettingsData && siteSettingsData?.Features,
                    getFeaturesList().golfer_experience
                  ) &&
                  getUserRole && getUserRole.Role != userRoles.BasicUser &&
                  (it.compKey == "today-pin" || it.compKey == "ghin")
                ) {
                  return it;
                } else if (
                  it.compKey != "car-behind" &&
                  it.compKey != "today-pin" &&
                  it.compKey != "today-round" &&
                  it.compKey != "pace-report" &&
                  it.compKey != "ghin" &&
                  it.compKey != "dash-pace" &&
                  it.compKey != "car-round-status"
                ) {
                  return it;
                }
              })
              ?.map((d) => {
                return d?.condition ? (
                  <TopBox
                    key={d?.compKey}
                    className={d.classname ? d.classname : ""}
                  >
                    {d?.comp}
                  </TopBox>
                ) : null;
              })}
          </ResponsiveGridLayout>
        </TopRow>

        {todayCampaignAdsCard ? (
          <CampaignAdsSlider>
            <TopBox>
              <div
                className="header"
                onClick={() => redirectToPage("today-camp-ads")}
              >
                <CameraIcon />
                <p className="green-border">{t("Todays_Campaign_Ads")}</p>
              </div>
              <div className="slider-section">
                <CampaignAds />
              </div>
            </TopBox>
          </CampaignAdsSlider>
        ) : null}
        <PaceFleetChartSection>
          {pacePlayReportCard &&
            !getFeatureSetOption(
              siteSettingsData && siteSettingsData?.Features,
              getFeaturesList().real_time_tracking
            ) &&
            getUserRole &&
            getUserRole.Role != 6 ? (
            <TopBox
              onClick={() => redirectToPage("pace")}
              className="fleet-car-rotation"
            >
              <PaceOfPlay />
            </TopBox>
          ) : null}
          {fleetUsageReportCard ? (
            <TopBox
              onClick={() => redirectToPage("fcr")}
              className="fleet-car-rotation"
            >
              <FleetUsageReports />
            </TopBox>
          ) : null}
        </PaceFleetChartSection>
      </BodyWrapper>
    </>
  );
};
